import { ActualTheme, GetActualThemesRequest } from '../../../typings';
import { getFetch } from '../fetch';
import { apiConfig } from '../config';

export function getActualThemes(requestData: GetActualThemesRequest): Promise<Array<ActualTheme>> {
    const { apiGetActualThemes } = apiConfig.getStaticUrls();

    return getFetch(apiGetActualThemes, requestData);
}
